// Centralized Color Configuration
// Based on the provided teal/cyan color palette

export const colors = {
  // Primary Colors
  primary: {
    50: '#CBF9FF',   // Pale Cyan
    100: '#A8EFF9',  // Very Light Cyan
    200: '#79E4F3',  // Light Cyan
    300: '#02C6E1',  // Bright Cyan
    400: '#009DB3',  // Vibrant Teal
    500: '#006B7A',  // Dark Teal
    600: '#005A66',  // Darker Teal
    700: '#004952',  // Darkest Teal
    800: '#00383E',  // Very Dark Teal
    900: '#00272A',  // Almost Black Teal
  },
  
  // Secondary Colors (complementary)
  secondary: {
    50: '#F0FDF4',   // Light Green
    100: '#DCFCE7',  // Very Light Green
    200: '#BBF7D0',  // Light Green
    300: '#86EFAC',  // Medium Green
    400: '#4ADE80',  // Green
    500: '#22C55E',  // Vibrant Green
    600: '#16A34A',  // Dark Green
    700: '#15803D',  // Darker Green
    800: '#166534',  // Very Dark Green
    900: '#14532D',  // Darkest Green
  },
  
  // Status Colors
  status: {
    success: '#22C55E',    // Green
    warning: '#F59E0B',    // Amber
    error: '#EF4444',      // Red
    info: '#3B82F6',       // Blue
    pending: '#F59E0B',    // Amber
    approved: '#22C55E',   // Green
    rejected: '#EF4444',   // Red
    underReview: '#3B82F6', // Blue
    submitted: '#6B7280',  // Gray
  },
  
  // Neutral Colors
  neutral: {
    50: '#F9FAFB',   // Very Light Gray
    100: '#F3F4F6',  // Light Gray
    200: '#E5E7EB',  // Medium Light Gray
    300: '#D1D5DB',  // Medium Gray
    400: '#9CA3AF',  // Gray
    500: '#6B7280',  // Medium Dark Gray
    600: '#4B5563',  // Dark Gray
    700: '#374151',  // Darker Gray
    800: '#1F2937',  // Very Dark Gray
    900: '#111827',  // Almost Black
  }
};

// Color utility functions
export const getStatusColor = (status) => {
  const statusMap = {
    'Under Review': `bg-blue-100 text-blue-800`,
    'Pending': `bg-yellow-100 text-yellow-800`,
    'Approved': `bg-green-100 text-green-800`,
    'Rejected': `bg-red-100 text-red-800`,
    'Closed': `bg-gray-100 text-gray-800`,
    'Submitted': `bg-gray-100 text-gray-800`,
  };
  return statusMap[status] || `bg-gray-100 text-gray-800`;
};

// CSS Custom Properties for dynamic theming
export const cssVariables = {
  '--color-primary-50': colors.primary[50],
  '--color-primary-100': colors.primary[100],
  '--color-primary-200': colors.primary[200],
  '--color-primary-300': colors.primary[300],
  '--color-primary-400': colors.primary[400],
  '--color-primary-500': colors.primary[500],
  '--color-primary-600': colors.primary[600],
  '--color-primary-700': colors.primary[700],
  '--color-primary-800': colors.primary[800],
  '--color-primary-900': colors.primary[900],
};

export default colors;
